import * as React from 'react';
import { v4 } from 'uuid';

export const useUniqueId = (prefix?: string) => `${prefix}-${React.useRef(v4()).current}`;
